import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

interface toWalletAddressState {
  toWalletAddress: string | undefined | any;
  fromWalletAddress: string | undefined | any;
  validAddressTo: boolean;
  validAddressFrom: boolean;
}

const initialState: toWalletAddressState = {
  toWalletAddress: undefined,
  fromWalletAddress: undefined,
  validAddressTo: false,
  validAddressFrom: false,
};

export const walletAddressSlice = createSlice({
  name: "walletAddressSlice",
  initialState,
  reducers: {
    setToWalletAddressData: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.toWalletAddress = action.payload;
    },
    setFromWalletAddressData: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.fromWalletAddress = action.payload;
    },
    setValidAddressToData: (state, action: PayloadAction<boolean>) => {
      state.validAddressTo = action.payload;
    },
    setValidAddressFromData: (state, action: PayloadAction<boolean>) => {
      state.validAddressFrom = action.payload;
    },
  },
});

export const {
  setToWalletAddressData,
  setFromWalletAddressData,
  setValidAddressToData,
  setValidAddressFromData,
} = walletAddressSlice.actions;

export default walletAddressSlice.reducer;
